module.exports = __webpack_public_path__ + "img/p8.2d1f0581.png";